/** Shared look of the manual-input editors (dark admin theme). */
import styled from '@emotion/styled';

export const Box = styled.div`
  padding: 20px 24px;
  color: rgba(255, 255, 255, 0.9);
  max-width: 720px;

  h3 { margin: 0 0 6px; font-size: 16px; }
  p.intro { margin: 0 0 14px; font-size: 13px; opacity: 0.75; line-height: 1.5; }
`;

export const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  flex: 1 1 160px;
  min-width: 0;
`;

const control = `
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: rgba(0, 0, 0, 0.35);
  color: #eee;
  font-size: 14px;
  font-family: inherit;
  min-height: 44px;
  box-sizing: border-box;
  width: 100%;
`;

export const Input = styled.input`${control}`;
export const Select = styled.select`${control}`;
export const TextArea = styled.textarea`
  ${control}
  min-height: 140px;
  resize: vertical;
  line-height: 1.5;
`;

export const Row = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: flex-end;
  margin-top: 12px;
`;

export const Button = styled.button`
  min-height: 44px;
  padding: 10px 16px;
  border-radius: 8px;
  border: 1px solid ${(p) => (p.$primary ? 'rgba(59, 130, 246, 0.5)' : 'rgba(255, 255, 255, 0.2)')};
  background: ${(p) => (p.$primary ? 'rgba(59, 130, 246, 0.15)' : 'rgba(255, 255, 255, 0.06)')};
  color: ${(p) => (p.$primary ? '#9cf' : 'rgba(255,255,255,0.85)')};
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;

  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

export const List = styled.ul`
  margin: 10px 0 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;

  li {
    padding: 8px 10px;
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.08);
  }
  .meta { opacity: 0.6; font-size: 12px; margin-left: 6px; }
`;

export const Note = styled.p`
  margin: 12px 0 0;
  font-size: 13px;
  color: ${(p) => (p.$error ? '#f88' : p.$warn ? '#ffc107' : '#8f8')};
`;
